<template>
  <ContainerComponent class="view-container">
    <div class="tile sm-12">
      <i class="icon icon-arrow-left text-xl" @click="$router.back()" />
      <div class="header">
        <h1>{{ customSelectionName }}</h1>
        <Legends />
      </div>
      <div class="row row-main">
        <div
          v-for="section in selectedProducts"
          :key="section.name"
          class="row h-center"
        >
          <div>
            <h2>{{ section.name }}</h2>
            <div class="products-list">
              <div
                v-for="radio in section.radios"
                :key="radio.name"
                class="product"
                :class="radio.category"
              >
                <img
                  width="192"
                  height="164"
                  class="mini_products"
                  :alt="radio.name"
                  :src="getRadio(radio.id)"
                  @click="e => clickProduct(e, radio, section)"
                  @error="onImageError"
                />
                <p>{{ radio.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ContainerComponent>
</template>

<script>
import { mapState } from 'vuex';
import { ContainerComponent, Legends } from '@/components';
import { getStaticUrl } from '@/helpers';
import axios from 'axios';

export default {
  components: {
    ContainerComponent,
    Legends
  },
  props: {
    sections: {
      type: Array,
      required: true
    }
  },
  data() {
    return {buildNumber: 0};
  },
  mounted() {
    axios.get(`${this.staticUrl}assetsConfig.json?` + Date.now()).then(result => {
      this.buildNumber = result.data.buildNumber;
    });
  },

  computed: {
    selectedProducts() {
      return Object.keys(this.customSelectionCheckedProducts).reduce(
        (acc, value) => {
          const arrayOfSelectedProducts = this.customSelectionCheckedProducts[
            value
          ];
          const section = this.keyedSections[value];
          if (
            section &&
            arrayOfSelectedProducts &&
            arrayOfSelectedProducts.length > 0
          ) {
            const radios = arrayOfSelectedProducts.reduce((racc, rvalue) => {
              const radio = section.radios[rvalue];
              if (radio) {
                racc[radio.id] = radio;
              }
              return racc;
            }, {});
            acc[value] = { ...section, radios };
          }
          return acc;
        },
        {}
      );
    },
    keyedSections() {
      return this.sections.reduce((acc, val) => {
        const radios = val.radios.reduce((racc, rval) => {
          racc[rval.id] = rval;
          return racc;
        }, {});

        acc[val.name] = { ...val, radios: radios };
        return acc;
      }, {});
    },
    ...mapState(['customSelectionName', 'customSelectionCheckedProducts'])
  },

  methods: {
    getRadio(id) {
      let image = null;
      try {
        image = `${getStaticUrl(this.radio, this.$route.name)}Images/${id}.png` + '?' + this.buildNumber;
      } catch {
        console.warn('Custom selection cannot find image for id ', id);
      }
      return image;
    },
    clickProduct(e, product, section) {
      this.$router.push({
        path: `overview/${section.prefix}${product.fileName}`
      });
    },
    onImageError() {}
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '~@eds/vanilla/variables/global.less';

.actionbars {
  display: flex;
  justify-content: flex-end;
}
.btn,
.primary {
  min-width: 116px;
}

.products-list {
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  .product {
    flex-basis: 192px;
    cursor: pointer;
    img {
      object-fit: contain;
    }
    margin-right: @space-base;
    margin-bottom: @space-base;
    background-color: #181818;
    p {
      padding-left: @space-base;
    }
    &.capacity {
      border-bottom: 4px solid @orange-50;
    }
    &.compact {
      border-bottom: 4px solid @green-35;
    }
    &.coverage {
      border-bottom: 4px solid @blue-43;
    }
  }
}
.tile {
  flex: 0 1 100%;
  position: relative;
}
.icon-arrow-left {
  position: absolute;
  bottom: @space-large;
  left: @space-large;
  cursor: pointer;
}
.space-between {
  justify-content: space-between;
}
.view-container {
  overflow: scroll;
}
.text-input-row {
  margin-bottom: @space-base;
}
.dark *::-webkit-scrollbar {
  background: #242424;
}
.row {
  .column {
    .sections {
      > :not(:first-child) {
        border-left: 1px solid @gray-31;
        padding-left: @space-base;
      }
      > div {
        flex-basis: 10%;
      }
    }
  }
}
.row-main {
  flex: 1;
  margin-bottom: @space-xxl;
}
.row-main > :not(:last-child) {
  margin-bottom: @space-large;
}
.header {
  display: flex;
  justify-content: space-between;
}
</style>
